@if (showNavigation) {
  <div class="{{navLinks}}">
    <app-header></app-header>
    <app-progressbar></app-progressbar>
    <app-navigation></app-navigation>
    <app-error></app-error>
  </div>
}

<main class="wrapper has-padding wrapper-padding-zoom">
  <h1 class="bofa--skiplink">Applicant Form</h1>
  <router-outlet>
    @if (show) {
      <div class="modal modal-overlay processing-overlay loading-indicator" id="modalContainer">
        <app-loading></app-loading>
      </div>
    }
  </router-outlet>
  <app-action-ui></app-action-ui>
</main>
@if (showNavigation) {
  <app-footer></app-footer>
}